import { render, staticRenderFns } from "./EditMagazineModal.vue?vue&type=template&id=73a58b3d&scoped=true&"
import script from "./EditMagazineModal.vue?vue&type=script&lang=js&"
export * from "./EditMagazineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a58b3d",
  null
  
)

export default component.exports